var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3207"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "star-fill 1",
    rx: 0,
    width: 31,
    height: 31,
    transform: "translate(0.500000 0.500000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "star-fill 1",
    rx: 0,
    width: 31,
    height: 31,
    transform: "translate(0.500000 0.500000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.31 14.29L23.67 19.21L25.36 26.54C25.45 26.92 25.42 27.32 25.29 27.69C25.15 28.06 24.91 28.38 24.59 28.61C24.27 28.84 23.89 28.97 23.5 28.99C23.1 29.01 22.72 28.91 22.38 28.71L15.99 24.83L9.61 28.71C9.28 28.91 8.89 29.01 8.5 28.99C8.1 28.97 7.72 28.84 7.41 28.61C7.09 28.38 6.85 28.06 6.71 27.69C6.57 27.32 6.55 26.92 6.63 26.54L8.32 19.22L2.68 14.29C2.38 14.04 2.17 13.7 2.06 13.32C1.96 12.94 1.96 12.54 2.09 12.16C2.21 11.79 2.44 11.46 2.75 11.21C3.05 10.97 3.43 10.82 3.82 10.79L11.25 10.14L14.15 3.22C14.31 2.86 14.56 2.55 14.89 2.33C15.22 2.11 15.6 2 15.99 2C16.39 2 16.77 2.11 17.1 2.33C17.43 2.55 17.68 2.86 17.84 3.22L20.74 10.14L28.17 10.79C28.57 10.82 28.94 10.97 29.25 11.21C29.56 11.46 29.79 11.79 29.91 12.16C30.03 12.54 30.04 12.94 29.93 13.32C29.83 13.7 29.61 14.04 29.31 14.29L29.31 14.29Z",
    fill: "#7252DC",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/starFill.b1aa721d8dbd6d244f3abd34e46526f0.svg";
export { ForwardRef as ReactComponent };